<template>
  <px-custom-dialog v-model="dialog" content-class="rounded-card"
                    :width="dialogWidth">
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
    </template>
    <template v-slot:title>
      Detalhes da resposta
      <v-btn class="ml-3" icon link target="_blank" :to="linkCotacao">
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </template>
    <template>
      <px-resposta-detalhes is-modal-view
                            :cotacao-id-prop="cotacaoId"
                            :resposta-id-prop="respostaId"
                            @change="onChange" />
    </template>
  </px-custom-dialog>
</template>

<script>
import RespostaDetalhes from '@/modules/cotacao/resposta/detalhes/RespostaDetalhes.vue';

export default {
  props: {
    cotacaoId: {
      type: [String, Number],
    },
    respostaId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    linkCotacao() {
      return `/cotacao/${this.cotacaoId}/respostas/${this.respostaId}`;
    },
    isSmall() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    dialogWidth() {
      return this.isSmall ? '95%' : '1400px';
    },
  },
  methods: {
    onChange() {
      this.$emit('change');
    },
  },
  components: {
    pxRespostaDetalhes: RespostaDetalhes,
  },
};
</script>
